import {Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-modal-process',
  templateUrl: './modal-process.component.html',
  styleUrls: ['./modal-process.component.css'],
})
export class ModalProcessComponent implements OnInit {
    sequence: number;
    fileList: any []= [];
    params: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ){
    // let param: any = this.route.params.subscribe(params => {
    //     console.log("params", JSON.parse(params.data))
    //     this.params = JSON.parse(params.data); 
    //     this.sequence = this.params.process_id;      
    //     this.getListFiles(this.params.list_file_names, this.params.file_name_tparty);
    //   });
  }

  ngOnInit(){

  }


//   getListFiles(data: string, file_tparty: string): void {
//       const regex = /[\{\}']+/g;
//       const cadena: string = data.replace(regex, "").trim();
//       let list_journal: any =data.split(";");
//       // console.log(list_journal)

//       for (var i = 0; i < list_journal.length; i++) {
//         // console.log(list_journal[i]);
//         this.fileList.push(list_journal[i]);
//       }
//       if(file_tparty != null){ 
//         this.fileList.push(file_tparty);
//       }
//     }

    loadProcess(): void {
        // this.uploadService.loadProcess(
        //   this.params,
        //   {
        //     success: (resp: any) => {
        //       console.log(resp)
        //       if (resp.status === 0) {
        //         this.router.navigate([`/accounting/process-detail`]);
        //       }
        //     },
        //     error: (err: any) => {
        //       console.log(err)
        //     }
        //   }
        // )
      }
    
      loadTypeMenu(): void {
        this.router.navigate([`load-type-menu`]);
      }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal-process/modal-process.component.ts